// Map from cart/order contents to the richer model used for editing
// We may be restoring from an old kit, so we only overwrite defaults with data we've validated against the catalog.
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { defaultDetectComponentState, defaultEncoderComponentState } from "./EditKitForm";
export var automatedIfKitToFormState = function (catalog, kit, kitPrice) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
    // Select the detect config by matching amp/label/channel triples, or fall back to the default.
    var defaultConfig = catalog.automatedIfDetect.configs[0];
    var selectedConfig = (function () {
        var _a, _b;
        if (kit.detectComponent) {
            var pairs_1 = kit.detectComponent.ampLabelPairs;
            return (_a = catalog.automatedIfDetect.configs.find(function (config) {
                return pairs_1.length === config.channels.length &&
                    pairs_1.every(function (pair) {
                        return config.channels.some(function (ch) {
                            return ch.hcrAmplifier.id === pair.hcrAmplifier.id &&
                                ch.fluorophore.id === pair.fluorophore.id &&
                                ch.channel === pair.channel;
                        });
                    });
            })) !== null && _a !== void 0 ? _a : {
                id: -1,
                channels: [],
                plexity: kit.plexity,
                label: ""
            };
        }
        if (kit.encoderComponent) {
            return (_b = catalog.automatedIfDetect.configs
                .find(function (c) { return c.plexity === kit.encoderComponent.encoderAmpPairs.length; })) !== null && _b !== void 0 ? _b : defaultConfig;
        }
        return defaultConfig;
    })();
    // Restore encoder state
    var primarySpeciesIds = [];
    if (kit.encoderComponent) {
        kit.encoderComponent.encoderAmpPairs.forEach(function (pair) {
            primarySpeciesIds = primarySpeciesIds.concat([pair.primarySpecies.id]);
        });
    }
    var encoderState = __assign(__assign({}, defaultEncoderComponentState(kit.plexity)), { primarySpeciesIds: primarySpeciesIds, encoderScaleUl: (_b = (_a = kit.encoderComponent) === null || _a === void 0 ? void 0 : _a.encoderScaleUl) !== null && _b !== void 0 ? _b : 0, antibodyBlockMl: (_d = (_c = kit.encoderComponent) === null || _c === void 0 ? void 0 : _c.antibodyBlockMl) !== null && _d !== void 0 ? _d : 0, antibodyDiluentMl: (_f = (_e = kit.encoderComponent) === null || _e === void 0 ? void 0 : _e.antibodyDiluentMl) !== null && _f !== void 0 ? _f : 0 });
    if (kitPrice === null || kitPrice === void 0 ? void 0 : kitPrice.encoderPriceCustom) {
        encoderState = __assign(__assign({}, encoderState), { customPrice: {
                listPriceCents: 0,
                effectivePriceCents: kitPrice.encoderPriceCents
            } });
    }
    // Restore detect state
    var detectState = __assign(__assign({}, defaultDetectComponentState(selectedConfig.id, (_g = kit.detectComponent) === null || _g === void 0 ? void 0 : _g.ampLabelPairs)), { detectAMl: (_j = (_h = kit.detectComponent) === null || _h === void 0 ? void 0 : _h.detectAMl) !== null && _j !== void 0 ? _j : 0, detectBMl: (_l = (_k = kit.detectComponent) === null || _k === void 0 ? void 0 : _k.detectBMl) !== null && _l !== void 0 ? _l : 0, detectCMl: (_o = (_m = kit.detectComponent) === null || _m === void 0 ? void 0 : _m.detectCMl) !== null && _o !== void 0 ? _o : 0 });
    if (kitPrice === null || kitPrice === void 0 ? void 0 : kitPrice.detectPriceCustom) {
        detectState = __assign(__assign({}, detectState), { customPrice: {
                listPriceCents: 0,
                effectivePriceCents: kitPrice.detectPriceCents
            } });
    }
    return {
        sampleTypeFormState: {
            sampleType: (_p = catalog.buffer.sampleTypes
                .find(function (t) { return t.id === kit.sampleType.id; })) !== null && _p !== void 0 ? _p : catalog.buffer.defaultSampleType
        },
        platformId: (_t = (_r = (_q = catalog.automatedIfPlatforms.find(function (p) { return p.id === kit.platform.id; })) === null || _q === void 0 ? void 0 : _q.id) !== null && _r !== void 0 ? _r : (_s = catalog.automatedIfPlatforms[0]) === null || _s === void 0 ? void 0 : _s.id) !== null && _t !== void 0 ? _t : '',
        selectedPresetScaleId: kit.presetScale ? (_u = catalog.automatedIfPresetScales.find(function (s) { return s.id === kit.presetScale.id; })) === null || _u === void 0 ? void 0 : _u.id : undefined,
        encoderEnabled: kit.encoderComponent !== undefined,
        detectEnabled: kit.detectComponent !== undefined,
        plexity: selectedConfig.plexity,
        encoderComponentState: encoderState,
        detectComponentState: detectState,
        comment: kit.comment,
        errors: [],
        priceLoading: false,
        price: undefined
    };
};
//# sourceMappingURL=AutomatedIfToFormState.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/automated-gold-if/AutomatedIfToFormState.js
// module id = 1162
// module chunks = 0